import React, { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NotificationBell = ({ onVideoClick }) => {
  const [notifs, setNotifs] = useState([]);
  const [open, setOpen] = useState(false);
  const [lastSeen, setLastSeen] = useState(() => localStorage.getItem('notif_seen') || '');

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/notifications`).then(r => setNotifs(r.data || [])).catch(() => {});
  }, []);

  const unseen = notifs.filter(n => n.created_at > lastSeen).length;

  const handleOpen = () => {
    setOpen(!open);
    if (!open && notifs.length > 0) {
      localStorage.setItem('notif_seen', notifs[0].created_at);
      setLastSeen(notifs[0].created_at);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <button onClick={handleOpen} className="notif-bell">
        <Bell size={18} />
        {unseen > 0 && <span className="notif-badge">{unseen}</span>}
      </button>
      {open && (
        <div className="notif-dropdown">
          <div className="notif-header">Notifications</div>
          {notifs.length === 0 ? (
            <div className="notif-empty">No notifications</div>
          ) : notifs.slice(0, 10).map(n => (
            <div key={n.id} className="notif-item" onClick={() => {
              if (n.video_id) window.location.href = `/?video=${n.video_id}`;
              setOpen(false);
            }}>
              <span className="notif-icon">🎬</span>
              <div>
                <div className="notif-text">{n.title}</div>
                <div className="notif-time">{new Date(n.created_at).toLocaleDateString()}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
